import { RouteReuseStrategy, DetachedRouteHandle, ActivatedRouteSnapshot } from '@angular/router';

/**
 * Custom route reuse strategy to cache the tickets routes in Repair Service and Order Tracking
 */
export class CustomReuseStrategy implements RouteReuseStrategy {
  handlers: { [key: string]: DetachedRouteHandle } = {};

  /**
   * This method determines whether a route should be removed from the router and stored for potential reuse.
   * In this case, we only want to cache the `TicketsTableComponent` route.
   */
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return !!route.data && !!route.data['key'];
  }

  /**
   * This method lets you decide how to store the detached route.
   */
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    if (route.data && route.data['key']) {
      this.handlers[route.data['key']] = handle;
    }
  }

  /**
   * This method checks if a stored route should be reattached instead of creating a new instance.
   */
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return !!route.data && !!this.handlers[route.data['key']];
  }

  /**
   * This method returns the stored route if it exists in the cache and is a match.
   */
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    if (!route.data || !this.handlers[route.data['key']]) {
      return null;
    }
    return this.handlers[route.data['key']];
  }

  /**
   * This method defines if a route should be reused based on its previous and current states.
   */
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}
